module.exports = __webpack_public_path__ + "img/Besenmodel.ea260bf7.jpg";